var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-row mb-2 mt-1"},[_c('div',{staticClass:"vx-col w-full"},[_c('span',{staticClass:"text-xs"},[_vm._v(_vm._s(_vm.fieldLabel))]),_c('vs-upload',{attrs:{"automatic":"","name":"file","limit":_vm.structure.fileLimit,"fileName":"file","text":"Upload","action":_vm.uploadUrl},on:{"on-success":_vm.successUpload}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }